import React from 'react';

/** 协议名称加书名号 */
export const formatAgreementName = (typeName) => {
  if (!typeName) {
    return '';
  }
  const trimmed = typeName.trim();
  if (trimmed.startsWith('《') && trimmed.endsWith('》')) {
    return trimmed;
  }
  return `《${trimmed}》`;
};

export const getAgreementKey = (item, index) => item.agreementId || item.typeName || index;

const isHtmlContent = (content) => /<[a-z][\s\S]*>/i.test(content);

/** 渲染协议正文（支持 HTML 或纯文本） */
export const renderAgreementContent = (content) => {
  if (!content) {
    return null;
  }
  if (isHtmlContent(content)) {
    return <div className="fh-agreement-content" dangerouslySetInnerHTML={{ __html: content }} />;
  }
  return <div className="fh-agreement-content fh-agreement-content-text">{content}</div>;
};
